"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'entityCard',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  computed: {
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    },
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.getters.deviceKeyObj;
    }
  },
  data: function data() {
    return {
      form: {},
      list: [],
      limitNumDialog: false,
      limitNumInfo: {},
      rechargeDialog: false,
      rechargeInfo: {
        row: null,
        type: 0,
        money: '',
        wash_gift_balance: ''
      },
      listLoading: true,
      listQuery: {
        start: 1,
        total: 10,
        page_num: 1
      }
    };
  },
  mounted: function mounted(options) {
    this.getList();
  },
  methods: {
    closeLoading: function closeLoading() {
      if (this.loadObj && typeof this.loadObj.close === 'function') {
        this.loadObj.close();
      }
      this.loadObj = null;
    },
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.form, this.listQuery, {
        start: this.listQuery.start - 1
      });
      this.$get('agentapi/card/query_nfc', listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 充值
     */
    recharge: function recharge(row) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.rechargeInfo = {
        row: row,
        type: type,
        money: '',
        wash_gift_balance: ''
      };
      this.rechargeDialog = true;
    },
    submitRecharge: function submitRecharge() {
      var _this2 = this;
      var _this$rechargeInfo = this.rechargeInfo,
        row = _this$rechargeInfo.row,
        money = _this$rechargeInfo.money,
        wash_gift_balance = _this$rechargeInfo.wash_gift_balance;
      var hasMoney = money !== '' && money != null;
      var hasGift = wash_gift_balance !== '' && wash_gift_balance != null;
      if (!hasMoney && !hasGift) {
        this.$message({
          message: '请填写充值金额或赠送余额',
          type: 'warning'
        });
        return;
      }
      this.loadObj = this.$loading({
        lock: true,
        text: '正在充值',
        spinner: 'el-icon-loading'
      });
      var promise = Promise.resolve();
      if (hasMoney) {
        promise = promise.then(function () {
          return _this2.$post('agentapi/business/invest_user_accout', {
            uid: row.bind_uid,
            type: 0,
            money: money
          });
        });
      }
      if (hasGift) {
        promise = promise.then(function () {
          return _this2.$post('agentapi/business/invest_user_accout', {
            uid: row.bind_uid,
            type: 2,
            money: wash_gift_balance
          });
        });
      }
      promise.then(function () {
        _this2.closeLoading();
        _this2.$message({
          message: '充值成功',
          type: 'success'
        });
        _this2.rechargeDialog = false;
        _this2.toQuery();
      }).catch(function () {
        _this2.closeLoading();
      });
    },
    /**
     * 储值卡退款（原路退回）
     */
    refund: function refund(row) {
      var _this3 = this;
      this.$prompt('请输入退款金额', '退款', {
        confirmButtonText: '确定退款',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入退款金额',
        inputType: 'text',
        beforeClose: function beforeClose(action, instance, done) {
          if (action == 'confirm') {
            _this3.loadObj = _this3.$loading({
              lock: true,
              text: '正在退款',
              spinner: 'el-icon-loading'
            });
            var value = instance.inputValue;
            var refundMoney = value < 0 ? Math.abs(value) : value;
            _this3.$post('agentapi/charging_card/launch_refund', {
              uid: row.bind_uid,
              withdraw_money: refundMoney,
              card_num: row.nfc_card_num,
              is_manage: 1
            }).then(function (res) {
              _this3.closeLoading();
              _this3.$message({
                message: '退款成功',
                type: 'success'
              });
              _this3.toQuery();
              done();
            }).catch(function (err) {
              _this3.closeLoading();
              done();
            });
          } else {
            done();
          }
        }
      });
    },
    /**
     * 解绑储值卡
     */
    unbindCard: function unbindCard(row) {
      var _this4 = this;
      var cardLabel = row.nfc_card_num || row.card_num || '该卡';
      this.$confirm("\u786E\u5B9A\u89E3\u7ED1\u5361\u53F7 ".concat(cardLabel, " \u5417\uFF1F\u89E3\u7ED1\u540E\u8BE5\u5361\u53EF\u91CD\u65B0\u7ED1\u5B9A\u5176\u4ED6\u7528\u6237\u3002"), '解绑卡', {
        confirmButtonText: '确定解绑',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.loadObj = _this4.$loading({
          lock: true,
          text: '正在解绑',
          spinner: 'el-icon-loading'
        });
        return _this4.$post('agentapi/charging_card/unbind_card', {
          card_id: row.id,
          card_num: row.nfc_card_num
        });
      }).then(function () {
        _this4.closeLoading();
        _this4.$message({
          message: '解绑成功',
          type: 'success'
        });
        _this4.toQuery();
      }).catch(function () {
        _this4.closeLoading();
      });
    },
    /**
     * 添加卡号
     */
    addrfid: function addrfid() {
      var _this5 = this;
      this.$prompt('请输入RFID卡号', 'RFID卡号添加', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '',
        inputType: 'text',
        beforeClose: function beforeClose(action, instance, done) {
          if (action == 'confirm') {
            _this5.loadObj = _this5.$loading({
              lock: true,
              text: '正在添加',
              spinner: 'el-icon-loading'
            });
            var value = instance.inputValue;
            _this5.$post('agentapi/business/add_rfid', {
              cardnum: value
            }).then(function (res) {
              _this5.closeLoading();
              _this5.$message({
                message: '添加成功',
                type: 'success'
              });
              _this5.toQuery();
              done();
            }).catch(function () {
              _this5.closeLoading();
            });
          } else {
            done();
          }
        }
      });
    },
    setCardFee: function setCardFee(row) {
      var _this6 = this;
      var is_fee_card = row.is_fee_card == 1 ? 0 : 1;
      this.loadObj = this.$loading({
        text: '提交中~~',
        spinner: 'el-icon-loading'
      });
      this.$post('agentapi/card/save_nfc_info', {
        is_fee_card: is_fee_card,
        card_id: row.id
      }).then(function (res) {
        row.is_fee_card = is_fee_card;
        _this6.closeLoading();
        _this6.$message({
          message: '设置成功',
          type: 'success'
        });
      }).catch(function (err) {
        _this6.closeLoading();
      });
    },
    setLimitCount: function setLimitCount() {
      var _this7 = this;
      this.$post('agentapi/card/save_nfc_info', {
        card_id: this.limitNumInfo.id,
        limit_use_num: this.limitNumInfo.limit_use_num,
        bind_uid: this.limitNumInfo.bind_uid
      }).then(function (res) {
        _this7.$message({
          message: '设置成功',
          type: 'success'
        });
        _this7.limitNumDialog = false;
        _this7.limitNumInfo.limit_use_num = _this7.limitNumInfo.limit_use_num;
        _this7.limitNumInfo.bind_uid = _this7.limitNumInfo.bind_uid;
      });
    },
    /**
     * 设置卡状态
     */
    setCard: function setCard(row) {
      var _this8 = this;
      var status = row.status == 1 ? 0 : 1;
      this.loadObj = this.$loading({
        text: '提交中~~',
        spinner: 'el-icon-loading'
      });
      this.$post('agentapi/card/save_nfc_info', {
        status: status,
        card_id: row.id
      }).then(function (res) {
        row.status = status;
        _this8.closeLoading();
        _this8.$message({
          message: '设置成功',
          type: 'success'
        });
      }).catch(function (err) {
        _this8.closeLoading();
      });
    }
  }
};